import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { deDE } from "@mui/x-date-pickers/locales";
import dayjs from "dayjs";
import { useCallback } from "react";

export default function SingleDatePicker({
  value,
  onChange,
  small = false,
  maximumDate,
  minimumDate,
  label,
}: {
  value: dayjs.Dayjs | null;
  onChange: (newDate: dayjs.Dayjs | null) => void;
  small?: boolean;
  maximumDate?: dayjs.Dayjs;
  minimumDate?: dayjs.Dayjs;
  label?: string;
}) {
  const handleChange = useCallback(
    (newDate: dayjs.Dayjs | null) => {
      onChange(newDate);
    },
    [onChange],
  );

  return (
    <LocalizationProvider adapterLocale="de" dateAdapter={AdapterDayjs} localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText}>
      <Box>
        <DatePicker
          enableAccessibleFieldDOMStructure={false}
          label={label}
          value={value}
          onChange={handleChange}
          minDate={minimumDate}
          maxDate={maximumDate}
          displayWeekNumber
          slotProps={{
            textField: {
              size: small ? "small" : "medium",
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
